const TileDomain = ({ data = {}, t }) => {
  const toStr = (v) =>
    typeof v === "string" ? v.trim() : typeof v === "number" ? String(v) : "";
  const url = toStr(data.url),
    certId = toStr(data.cert_id),
    commonName = toStr(data.common_name);
  const issuerCaId = toStr(data.issuer_ca_id),
    issuerName = toStr(data.issuer_name);
  const nameValue = toStr(data.name_value),
    serialNumber = toStr(data.serial_number);
  if (
    !url &&
    !certId &&
    !commonName &&
    !issuerCaId &&
    !issuerName &&
    !nameValue &&
    !serialNumber
  )
    return null;
  const fields = [
    { label: "Certificate ID", value: certId },
    { label: "Common Name", value: commonName },
    { label: "Issuer CA ID", value: issuerCaId },
    { label: "Issuer Name", value: issuerName },
    { label: "Name Value", value: nameValue },
    { label: "Serial Number", value: serialNumber },
  ].filter((f) => f.value);
  const labelS = {
    fontSize: 10,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    fontWeight: 500,
    color: t.textMuted,
    margin: 0,
  };
  const valS = {
    fontSize: 13,
    color: t.textSecondary,
    margin: 0,
    wordBreak: "break-word",
  };

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {url && (
          <p
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: t.textPrimary,
              margin: 0,
              wordBreak: "break-word",
              lineHeight: 1.4,
            }}
          >
            {url}
          </p>
        )}
        {fields.length > 0 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
              paddingTop: 12,
              borderTop: `1px solid ${t.divider}`,
            }}
          >
            {fields.map(({ label, value }) => (
              <div key={label}>
                <p style={labelS}>{label}</p>
                <p
                  style={{
                    ...valS,
                    ...(label === "Serial Number"
                      ? { fontFamily: "monospace", fontSize: 11 }
                      : {}),
                  }}
                >
                  {value}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TileDomain;
